export const dict = {
  hi: {
    nav: {
      home: "होम", services: "सेवाएं", ultrasound: "अल्ट्रासाउंड", opd: "ओपीडी",
      ipd: "आईपीडी", xray: "एक्स-रे", ct: "सीटी स्कैन", mri: "एमआरआई",
      pharmacy: "फार्मेसी", pathology: "पैथोलॉजी", about: "हमारे बारे में", contact: "संपर्क",
      login: "लॉगिन", dashboard: "डैशबोर्ड", admin: "एडमिन", logout: "लॉगआउट",
      bookNow: "अभी बुक करें",
    },
    hero: {
      badge: "भारत का भरोसेमंद स्वास्थ्य मंच",
      title: "एक क्लिक में स्वास्थ्य सेवाओं की बुकिंग",
      subtitle: "अल्ट्रासाउंड, ओपीडी, एक्स-रे, सीटी स्कैन, एमआरआई और दवाइयों की होम डिलीवरी – सब कुछ एक ही जगह।",
      cta1: "अभी बुक करें", cta2: "फार्मेसी देखें",
      stat1: "50K+ मरीज़", stat2: "200+ डॉक्टर", stat3: "24×7 सहायता",
    },
    services: {
      title: "हमारी सेवाएं", sub: "अपनी ज़रूरत की सेवा चुनें",
      ultrasound: { name: "अल्ट्रासाउंड", desc: "सुरक्षित और सटीक स्कैन", fee: "₹199 प्लेटफ़ॉर्म शुल्क" },
      opd: { name: "ओपीडी अपॉइंटमेंट", desc: "विशेषज्ञ डॉक्टर से मिलें", fee: "₹99 प्लेटफ़ॉर्म शुल्क" },
      ipd: { name: "आईपीडी भर्ती", desc: "अस्पताल में भर्ती की सुविधा", fee: "₹499 शुल्क" },
      xray: { name: "डिजिटल एक्स-रे", desc: "तुरंत रिपोर्ट", fee: "₹149 प्लेटफ़ॉर्म शुल्क" },
      ct: { name: "सीटी स्कैन", desc: "उच्च-गुणवत्ता इमेजिंग", fee: "₹299 प्लेटफ़ॉर्म शुल्क" },
      mri: { name: "एमआरआई", desc: "एडवांस एमआरआई मशीन", fee: "₹399 प्लेटफ़ॉर्म शुल्क" },
      pharmacy: { name: "ऑनलाइन फार्मेसी", desc: "दवाइयां घर पर", fee: "मुफ्त डिलीवरी ₹500+" },
      pathology: { name: "पैथोलॉजी टेस्ट", desc: "CBC, थायरॉइड, शुगर आदि · होम कलेक्शन", fee: "₹49 प्लेटफ़ॉर्म शुल्क" },
    },
    common: {
      loading: "लोड हो रहा है...", search: "खोजें", cancel: "रद्द करें",
      confirm: "पुष्टि करें", next: "आगे", back: "पीछे", pay: "भुगतान करें",
      selectDoctor: "डॉक्टर चुनें", selectDate: "तारीख चुनें", selectSlot: "समय चुनें",
      patientDetails: "मरीज़ की जानकारी", name: "नाम", age: "उम्र", gender: "लिंग",
      phone: "फ़ोन", email: "ईमेल", address: "पता", notes: "नोट्स",
      male: "पुरुष", female: "महिला", other: "अन्य",
      total: "कुल", platformFee: "प्लेटफ़ॉर्म शुल्क", testFee: "टेस्ट शुल्क",
      consultFee: "परामर्श शुल्क", proceed: "आगे बढ़ें", bookings: "बुकिंग्स",
      payments: "भुगतान", noBookings: "कोई बुकिंग नहीं", welcome: "स्वागत है",
    },
    footer: {
      about: "AASAN OPD भारत में स्वास्थ्य सेवाओं तक आसान पहुँच प्रदान करता है।",
      quickLinks: "त्वरित लिंक", legal: "क़ानूनी", contact: "संपर्क करें",
      terms: "शर्तें और नियम", privacy: "गोपनीयता नीति",
      refund: "रिफ़ंड नीति", help: "मदद और सहायता",
      rights: "सर्वाधिकार सुरक्षित", location: "बेगूसराय, बिहार",
    },
  },
  en: {
    nav: {
      home: "Home", services: "Services", ultrasound: "Ultrasound", opd: "OPD",
      ipd: "IPD", xray: "X-Ray", ct: "CT Scan", mri: "MRI",
      pharmacy: "Pharmacy", pathology: "Pathology", about: "About", contact: "Contact",
      login: "Login", dashboard: "Dashboard", admin: "Admin", logout: "Logout",
      bookNow: "Book Now",
    },
    hero: {
      badge: "India's Trusted Healthcare Platform",
      title: "Book Healthcare Services in One Click",
      subtitle: "Ultrasound, OPD, X-Ray, CT Scan, MRI and medicine home delivery — all in one place.",
      cta1: "Book Now", cta2: "Browse Pharmacy",
      stat1: "50K+ Patients", stat2: "200+ Doctors", stat3: "24×7 Support",
    },
    services: {
      title: "Our Services", sub: "Pick the service you need",
      ultrasound: { name: "Ultrasound", desc: "Safe & precise scans", fee: "₹199 platform fee" },
      opd: { name: "OPD Appointment", desc: "Meet expert doctors", fee: "₹99 platform fee" },
      ipd: { name: "IPD Admission", desc: "Hospital admission assist", fee: "₹499 fee" },
      xray: { name: "Digital X-Ray", desc: "Instant reports", fee: "₹149 platform fee" },
      ct: { name: "CT Scan", desc: "High-quality imaging", fee: "₹299 platform fee" },
      mri: { name: "MRI", desc: "Advanced MRI machines", fee: "₹399 platform fee" },
      pharmacy: { name: "Online Pharmacy", desc: "Medicines to your door", fee: "Free delivery ₹500+" },
    },
    common: {
      loading: "Loading...", search: "Search", cancel: "Cancel",
      confirm: "Confirm", next: "Next", back: "Back", pay: "Pay",
      selectDoctor: "Select Doctor", selectDate: "Select Date", selectSlot: "Select Slot",
      patientDetails: "Patient Details", name: "Name", age: "Age", gender: "Gender",
      phone: "Phone", email: "Email", address: "Address", notes: "Notes",
      male: "Male", female: "Female", other: "Other",
      total: "Total", platformFee: "Platform Fee", testFee: "Test Fee",
      consultFee: "Consultation Fee", proceed: "Proceed", bookings: "Bookings",
      payments: "Payments", noBookings: "No bookings yet", welcome: "Welcome",
    },
    footer: {
      about: "AASAN OPD provides easy access to quality healthcare across India.",
      quickLinks: "Quick Links", legal: "Legal", contact: "Contact Us",
      terms: "Terms & Conditions", privacy: "Privacy Policy",
      refund: "Refund Policy", help: "Help & Support",
      rights: "All rights reserved", location: "Begusarai, Bihar",
    },
  },
};

export const t = (lang, path) => {
  const parts = path.split(".");
  let node = dict[lang] || dict.en;
  for (const p of parts) {
    if (node && typeof node === "object" && p in node) node = node[p];
    else return path;
  }
  return node;
};
